var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6666 0.666992C8.82568 0.666992 7.33329 2.15938 7.33329 4.00033V5.66699H3.99996C2.15901 5.66699 0.666626 7.15938 0.666626 9.00033V14.0003C0.666626 15.8413 2.15901 17.3337 3.99996 17.3337H7.33329C9.17424 17.3337 10.6666 15.8413 10.6666 14.0003V12.3337H14C15.8409 12.3337 17.3333 10.8413 17.3333 9.00033V4.00033C17.3333 2.15938 15.8409 0.666992 14 0.666992H10.6666ZM10.6666 10.667H14C14.9204 10.667 15.6666 9.9208 15.6666 9.00033V4.00033C15.6666 3.07985 14.9204 2.33366 14 2.33366H10.6666C9.74615 2.33366 8.99996 3.07985 8.99996 4.00033V6.11293C9.99629 6.68928 10.6666 7.76652 10.6666 9.00033V10.667ZM2.33329 9.00033C2.33329 8.07985 3.07948 7.33366 3.99996 7.33366H7.33329C8.25377 7.33366 8.99996 8.07985 8.99996 9.00033V14.0003C8.99996 14.9208 8.25377 15.667 7.33329 15.667H3.99996C3.07948 15.667 2.33329 14.9208 2.33329 14.0003V9.00033Z",
    fill: "#379E66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.468004ab3a792700303b4714d51497a8.svg";
export { ForwardRef as ReactComponent };